<template>
    <b-container>
        <div class="teams">
            <h1>School Location</h1>
            <b-row>
            <b-col class="my-1">
                <b-form-group
                label="Search:"
                label-for="filter-input"
                label-cols-sm="1"
                label-size="sm"
                class="mb-0"
                >
                <b-input-group size="sm">
                    <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    ></b-form-input>

                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>


            <b-col lg="6" class="my-1">
                <b-form-group
                label="Filter:"
                label-for="sort-by-select"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
                >
                <b-input-group size="sm">
                    <b-form-select
                    v-model="status"
                    :aria-describedby="ariaDescribedby"
                    size="sm"
                    class="w-25"
                    :options="statusOptions"
                    >
                    </b-form-select>
                </b-input-group>
                </b-form-group>
            </b-col>
            </b-row>
            <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="statusFilter"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(school_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditSchool', params: { id: row.item.school_uuid } }"
                    >{{ row.item.school_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                <template slot="cell(trainer_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTrainer', params: { id: row.item.trainer_uuid } }"
                    >{{ row.item.trainer_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(lat)" slot-scope="row">
                    <small class="small-date"> lat: {{ row.item.old_lat }},lng: {{ row.item.old_lng }} </small > <br>

                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->

                    <b-button id="show-btn" size="sm" @click="openMapModal(row.item.old_lat,row.item.old_lng,'Current Location')">view</b-button>

                </template>
                 <template slot="cell(lng)" slot-scope="row">

                     <small class="small-date"> lat: {{ row.item.lat }},lng: {{ row.item.lng }} </small > <br>

                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->

                    <b-button id="show-btn" size="sm" @click="openMapModal(row.item.lat,row.item.lng,'Current Location')">view</b-button>

                </template>
                <template slot="cell(status)" slot-scope="row">

                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.status }}</p>
                </template>
                 <template slot="cell(created_at)" slot-scope="row">

                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ getHumanDate(row.item.updated_at) }}</p>
                </template>
                <template slot="cell(id)" slot-scope="row">
                   <div class="mt-3">
                        <b-button-group>
                            <b-button v-if="row.item.status == 'new' || row.item.status == 'declined'"  @click.stop="approveSchoolLocation(row.item)" variant="success">Approve</b-button>
                            <b-button v-if="row.item.status == 'new' || row.item.status == 'approved'"  @click.stop="declineSchoolLocation(row.item)" variant="danger">Decline</b-button>
                        </b-button-group>
                    </div>

                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="statusFilter.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>
        </div>
        <div>

            <b-modal ref="map-modal" hide-footer>
                <template #modal-title>
                    {{ mapModalTitle }}
                </template>
                <div class="d-block text-center">
                    <div>
                        <GmapMap
                            :center='center'
                            :zoom='12'
                            style='width:100%;  height: 400px;'
                            />
                    </div>
                </div>
            </b-modal>
        </div>


    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SchoolLocation from "@/services/SchoolLocationService";
import moment from "moment"
import { checkToken } from "../utils/helpers";

export default {
    name:"SchoolLocation",
    data(){
        return {
             fields: [
            { key: "school_name", label: "School Name", sortable: true },
            { key: "trainer_name", label: "Trainer" },
            { key: "lat", label: "Current location" },
            { key: "lng", label: "New location" },
            { key: "status", label: "Status" },
            { key: "created_at", label: "Date" },
            { key: "id", label: "Action" },
            // { key: "active", label: "Active" },
        //    { key: "uuid", label: "Active" },
        ],
        currentPage: 1,
        perPage: 5,
        filter: null,
        locations:[],
        status:"",
        statusOptions:[
            {value:"",text:"-- none --"},
            {value:"approved",text:"Approved"},
            {value:"new",text:"New"},
            {value:"declined",text:"Declined"},
        ],
        center: { lat: 45.508, lng: -73.587 },
        mapModalTitle:"",
        }
    },
    methods:{
        stopClick() {},
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async fetchSchoolLocations(){
            const user = checkToken() && JSON.parse(localStorage.getItem("userLogin"));
            let tmp;
            if(user.src){
                console.log("is src");
                tmp = await SchoolLocation.getSchoolLocationsSRC(user.uuid);
            }else{
                console.log("is admin");
                tmp = await SchoolLocation.getSchoolLocations();
            }

            this.locations = tmp.data.results;
        },
        async declineSchoolLocation(val){
            var tmp = {id:val.id,status:"declined"}
            await SchoolLocation.updateSchoolLocation(tmp);
            location.reload();
        },
        async approveSchoolLocation(val){
            var tmp = {id:val.id,status:"approved",lat:val.lat,lng:val.lng,school_id:val.school_id}
            await SchoolLocation.updateSchoolLocation(tmp);
            location.reload();
        },
        openMapModal(lat,lng,title){
            this.center.lat = lat;
            this.center.lng = lng;
            this.mapModalTitle = title;
            this.$refs['map-modal'].show();
        },
        getHumanDate(date) {
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
    },
    computed: {
        ...mapGetters({
        isAdmin: "auth/isAdmin",
        }),
        statusFilter(){
            return this.locations.filter(e=> {
                    if(this.status !=""){
                        if(e.status == this.status){
                            return true;
                        }
                    }else{
                        return true;
                    }
                });
        }
    },
    created(){
        this.fetchSchoolLocations();
    }
}
</script>